<template>
  <div class="start">
    <h1 class="start__title">Ивентинка  </h1>

    <div class="start__body">
      <p>Любви много не бывает, особенно к мероприятиям</p>
      <p>Пришло время узнать, с каким мероприятием у вас точно сложится особая любовь и понимание.</p>
    </div>

    <button @click="$emit('goNext')" class="start__btn">Найти любовь</button>
  </div>
</template>

<script>
export default {}
</script>
